import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import inStockProjects from '../data/in_stock_projects.json'
import additionsAndConversions from '../data/additions_and_conversions.json'
import constructionServiceProjects from '../data/construction_service_projects.json'
import renovations from '../data/renovations.json'
import servicesOverview from '../data/services_overview.json'

export const Context = React.createContext()

class Provider extends Component {
    state = {
        sideMenu: false,
        infoMenu: false,
        inStockProjects: inStockProjects,
        additionsAndConversions: additionsAndConversions,
        constructionServiceProjects: constructionServiceProjects,
        renovations: renovations,
        servicesOverview: servicesOverview,
        historyBack: null,
        activeReferenceItemType: null,
        activeReferenceItemIndex: null,
        activeReferenceItem: null,
    }
    updateState = state => {
        this.setState(state)
    }

    getActiveReferenceItem(activeReferenceItemType, activeReferenceItemIndex) {
        if (activeReferenceItemType != null && activeReferenceItemIndex != null) {
            if (activeReferenceItemType === 'bauen-im-bestand') {
                return { ...this.state.inStockProjects[activeReferenceItemIndex], typeTitle: 'Bauen im Bestand' }
            } else if (activeReferenceItemType === 'bauservice') {
                return { ...this.state.constructionServiceProjects[activeReferenceItemIndex], typeTitle: 'Bauservice' }
            }
            return null
        }
    }

    componentWillMount() {
        this.handleNewLocation(this.props.location)
    }

    componentWillReceiveProps(nextProps) {
        this.handleNewLocation(nextProps.location)
    }

    handleNewLocation(location) {
        let activeReferenceItemType = null
        let activeReferenceItemIndex = null

        const pathname = location.pathname
        const pathArray = pathname.substring(1).split('/')

        //console.log('pathArray', pathArray)

        let historyBack = null
        if (pathArray && pathArray.length > 0 && pathArray[0] !== '') {
            historyBack = '/' + pathArray.slice(0, -1).join('/')
            if (pathArray.length === 3 && pathArray[1] === 'referenzen') {
                activeReferenceItemType = pathArray[0]
                activeReferenceItemIndex = Number(pathArray[2])
            }
        }

        if (this.state.activeReferenceItemType !== activeReferenceItemType || this.state.activeReferenceItemIndex !== activeReferenceItemIndex || this.state.historyBack !== historyBack) {
            this.setState({
                activeReferenceItemType,
                activeReferenceItemIndex,
                activeReferenceItem: this.getActiveReferenceItem(activeReferenceItemType, activeReferenceItemIndex),
                sideMenu: false,
                infoMenu: false,
                historyBack: historyBack,
            })
        }
    }

    render() {
        return (
            <Context.Provider
                value={{
                    state: this.state,
                    props: this.props,
                    updateState: this.updateState,
                }}
            >
                {this.props.children}
            </Context.Provider>
        )
    }
}

export default withRouter(Provider)
